<template>
  <div class="incellderm-sns--go mt-4">
    <a
      href="https://www.instagram.com/lifening.official/"
      target="_blank"
    >
      <img src="@/assets/images/common/ico_insta.svg" class="incellderm-sns--youtube" alt="인스타그램" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'SnsBtn',
};
</script>

<style></style>
